import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { WidgetTable } from "../Widgets/WidgetTable";
import { DynPopup } from "../../../Components/DynPopup";
import { DropDownComponent } from "../../../Components/DropDownComponent";
import { TextComponent } from "../../../Components/TextComponent";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { app } from "../../../Frame/App";
import { LanguageString } from "../../../Model/LanguageString";

export type PopupTableComponentProps = {
    widget: WidgetTable;
}

export class PopupTableComponent extends JSXComponent {
    props: PopupTableComponentProps;
    dropdown: DropDownComponent;
    title: LanguageStringComponent;

    constructor(props: PopupTableComponentProps) {
        super(props);
    }

    onSave = (): boolean => {
        this.props.widget.props.viewType = this.dropdown.getValue();
        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;
        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement =
        <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetTable}>
            {this.renderDropdown()}
            {this.renderTitle()}
            <div style={{ height: "10rem" }}></div>
        </DynPopup>

    renderDropdown(): HTMLElement {
        let items = [
            { name: Resources['WidgetClient'].massnahmenListe, value: "MassnahmenListe" },
            { name: Resources['WidgetClient'].meineMassnahmen, value: "MeineMassnahmen" },
            { name: Resources['WidgetClient'].meineZustaendig, value: "MeineZustaendig" }
        ];

        if (app.customApp == "PagPcms") {
            items.push({ name: "Meine Handlungsfelder", value: "PagPcmsMeineHandlungsfelder" });
            items.push({ name: "Meine Self-Checks", value: "PagPcmsMeineSelfChecks" });
            items.push({ name: "Meine Verbesserungsmaßnahmen", value: "PagPcmsMeineVerbesserungsmassnahmen" });
        }

        this.dropdown = new DropDownComponent({
            id: "popupTableListView",
            name: Resources['WidgetClient'].listView,
            displayProperty: "name",
            valueProperty: "value",
            addEmptyItem: true,
            items: items
        });
        return this.dropdown.render();
    }

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses:"name-in-languages",
            maxLength:250,
            showLabel:true,
            alwaysExpanded:false
        });
        return this.title.render();
    }

    render(): HTMLElement {
        if (this.props.widget.props.viewType) {
            this.dropdown.setValue(this.props.widget.props.viewType);
        }
        return this.element;
    }
}
